import { render, staticRenderFns } from "./TravelerSnapshots.vue?vue&type=template&id=228fe362&scoped=true&"
import script from "./TravelerSnapshots.vue?vue&type=script&lang=js&"
export * from "./TravelerSnapshots.vue?vue&type=script&lang=js&"
import style0 from "./TravelerSnapshots.vue?vue&type=style&index=0&id=228fe362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228fe362",
  null
  
)

export default component.exports